import { FC, PropsWithChildren } from "react";
import styled from 'styled-components';

const Main: FC<PropsWithChildren<object>> = ({ children }) => {
  return <Root>{children}</Root>;
};
export default Main;

const Root = styled.main`
  color: white;
  @media screen and (max-width: 960px) {
    margin-top: 50px;
  }
  @media screen and (min-width: 961px) {
    margin-top: 70px; 
  }
  & > :last-child {
    margin-bottom: 50px;
  }
`;
